import { React } from "react"
import { X } from "lucide-react"
import styles from "../../../components/ui/dialog.module.css"

export const ConfirmationModal = ({ isOpen, onClose, onConfirm, action, applicationId }) => {
  if (!isOpen) return null

  return (
    <div className={styles.dialogOverlay} onClick={onClose}>
      <div className={styles.dialogContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.dialogHeader}>
          <h2 className={styles.dialogTitle}>Confirm {action === "hire" ? "Hire" : "Reject"}</h2>
          <button onClick={onClose} className={styles.closeButton} aria-label="Close">
            <X size={24} />
          </button>
        </div>
        <div className={styles.dialogBody}>
          <p>Are you sure you want to {action === "hire" ? "hire" : "reject"} this applicant?</p>
          <div className="mt-4 flex justify-end space-x-2">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className={`px-4 py-2 text-white rounded hover:opacity-90 transition-colors ${
                action === "hire" ? "bg-green-500 hover:bg-green-600" : "bg-red-500 hover:bg-red-600"
              }`}
            >
              Confirm {action === "hire" ? "Hire" : "Reject"}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

